import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

const SUPPORTED = ["it", "en", "es"];

function detectLang() {
  // 1. Manual override always wins
  const stored = localStorage.getItem("site_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;
  // 2. Otherwise detect from the browser preferences
  const candidates =
    typeof navigator !== "undefined" && navigator.languages && navigator.languages.length
      ? navigator.languages
      : [typeof navigator !== "undefined" ? navigator.language : "it"];
  for (const c of candidates) {
    if (!c) continue;
    const code = c.slice(0, 2).toLowerCase();
    if (SUPPORTED.includes(code)) return code;
  }
  // 3. Fallback to Italian
  return "it";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => detectLang());

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("site_lang", l);
    setLangState(l);
  };

  const t = (key) => (translations[lang] && translations[lang][key]) || translations.it[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
